import { render, staticRenderFns } from "./TracksList.vue?vue&type=template&id=8195b2d0&"
import script from "./TracksList.vue?vue&type=script&lang=js&"
export * from "./TracksList.vue?vue&type=script&lang=js&"
import style0 from "./TracksList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports